import {
    CREATE_YARN_INWARD_FAILURE_DK,
    CREATE_YARN_INWARD_REQUEST_DK,
    CREATE_YARN_INWARD_SUCCESS_DK,
    CREATE_USER_FORM_YARN_INWARD_DK,
    FETCH_SINGLE_YARN_INWARD_FAILURE_DK,
    FETCH_SINGLE_YARN_INWARD_REQUEST_DK,
    FETCH_SINGLE_YARN_INWARD_SUCCESS_DK,
    FETCH_YARN_INWARD_FAILURE_DK,
    FETCH_YARN_INWARD_REQUEST_DK,
    FETCH_YARN_INWARD_SUCCESS_DK,
    NAVIGATE_YARN_INWARD_DETAILS_DK,
    NAVIGATE_YARN_INWARD_DK,
    YARN_INWARD_USERFORM_RESET_DK,
    UPDATE_YARN_INWARD_FAILURE_DK,
    UPDATE_YARN_INWARD_REQUEST_DK,
    UPDATE_YARN_INWARD_SUCCESS_DK,
    DELETE_YARN_INWARD_REQUEST_DK,
    DELETE_YARN_INWARD_SUCCESS_DK,
    DELETE_YARN_INWARD_FAILURE_DK,
    FETCH_PENDING_YARN_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_YARN_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_YARN_PO_IN_INWARD_FAILURE_DK,
    RESET_FORM_DATA_WITHOUT_INWARD_ID_DK,
    SET_ACTIVE_KEY_YARN_INWARD_DK,
    SET_PENDING_GRID_NAME_YARN_INWARD_DK,
    SET_UNIT_NAME_YARN_INWARD_DK,
    FETCH_COMPLETE_YARN_PO_IN_INWARD_REQUEST_DK,
    FETCH_COMPLETE_YARN_PO_IN_INWARD_SUCCESS_DK,
    FETCH_COMPLETE_YARN_PO_IN_INWARD_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK
} from './yarnInward.actionsType';

export const YARN_INWARD_DK = 'yarnInwardDK';

let initialState = {
    loading: false,
    yarnInward: [],
    pendingYarnPO: [],
    completeYarnPO: [],
    reportSingleYarnProgramInwardList: [],
    activeKey: 1,
    yarnInwardId: '',
    detailsId: [],
    yarnInwardForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldRoundoff: 0
    },
    selectedTeam: {},
    renderGridBtn: 'pendingGrid',
    unitId: '',
    isYarnInward: false,
    yarnInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let yarnInwardDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_YARN_INWARD_REQUEST_DK:
        case FETCH_PENDING_YARN_PO_IN_INWARD_REQUEST_DK:
        case FETCH_COMPLETE_YARN_PO_IN_INWARD_REQUEST_DK:
        case CREATE_YARN_INWARD_REQUEST_DK:
        case FETCH_SINGLE_YARN_INWARD_REQUEST_DK:
        case UPDATE_YARN_INWARD_REQUEST_DK:
        case DELETE_YARN_INWARD_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnInward: updatePayload
            };
        case FETCH_PENDING_YARN_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingYarnPO: updatePayload
            };
        case FETCH_COMPLETE_YARN_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                completeYarnPO: updatePayload
            };
        case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportSingleYarnProgramInwardList: updatePayload?.Inward
            };
        case CREATE_YARN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                yarnInwardId: updatePayload[0]?.fldID,
                detailsId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_SINGLE_YARN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                yarnInwardForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_YARN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: {},
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case DELETE_YARN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case FETCH_YARN_INWARD_FAILURE_DK:
        case FETCH_PENDING_YARN_PO_IN_INWARD_FAILURE_DK:
        case FETCH_COMPLETE_YARN_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_YARN_INWARD_FAILURE_DK:
        case CREATE_YARN_INWARD_FAILURE_DK:
        case UPDATE_YARN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
        case DELETE_YARN_INWARD_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_YARN_INWARD_DK:
            return {
                ...state,
                loading: false,
                yarnInwardForm: {
                    ...state.yarnInwardForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_YARN_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_PENDING_GRID_NAME_YARN_INWARD_DK:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_YARN_INWARD_DK:
            return {
                ...state,
                unitId: payload
            };
        case YARN_INWARD_USERFORM_RESET_DK:
            return {
                ...state,
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                yarnInwardId: '',
                detailsId: [],
                activeKey: 1,
                selectedTeam: {}
            };
        case RESET_FORM_DATA_WITHOUT_INWARD_ID_DK:
            return {
                ...state,
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_YARN_INWARD_DETAILS_DK:
            return {
                ...state,
                isYarnInward: true,
                yarnInwardSelectedValue: updatePayload.yarnInwardSelectedValue
            };
        case NAVIGATE_YARN_INWARD_DK:
            return {
                ...state,
                isYarnInward: false
            };
        default:
            return state;
    }
};
